import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './met-profession.reducer';
import { IMetProfession } from 'app/shared/model/met-profession.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetProfession = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const metProfessionList = useAppSelector(state => state.metProfession.entities);
  const loading = useAppSelector(state => state.metProfession.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="met-profession-heading" data-cy="MetProfessionHeading">
        <Translate contentKey="almobadaraMasterDataApp.metProfession.home.title">Met Professions</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.metProfession.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.metProfession.home.createLabel">Create new Met Profession</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {metProfessionList && metProfessionList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProfession.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProfession.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProfession.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProfession.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProfession.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metProfession.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {metProfessionList.map((metProfession, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${metProfession.id}`} color="link" size="sm">
                      {metProfession.id}
                    </Button>
                  </td>
                  <td>{metProfession.code}</td>
                  <td>{metProfession.name}</td>
                  <td>{metProfession.nameAr}</td>
                  <td>{metProfession.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${metProfession.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${metProfession.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${metProfession.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metProfession.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.metProfession.home.notFound">No Met Professions found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MetProfession;
